/* eslint-disable @typescript-eslint/no-explicit-any */
export var ColumnType;

(function (ColumnType) {
  ColumnType["TEXT"] = "text";
  ColumnType["NUMERIC"] = "numeric";
})(ColumnType || (ColumnType = {}));